// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2Yy5y","item":"styles_item__3y-Bj","carousel":"styles_carousel__EvBNL","image":"styles_image__kflyY"};